import { type ReactNode, createContext, useContext } from "react";
import type { ITickerEditorData, ITickerSettings } from "../types";
import { ensureTickerElementSettings } from "../utils";

export interface ITickerCtx {
  isHorizontal: boolean;
  isVertical: boolean;
  shouldAnimate: boolean;
  isAnimReverse: boolean;
  editorData?: ITickerEditorData;
  elementSettings: ITickerSettings;
}

const initState: ITickerCtx = {
  isHorizontal: true,
  isVertical: false,
  shouldAnimate: false,
  isAnimReverse: false,
  elementSettings: ensureTickerElementSettings(),
};

export const TickerCtx = createContext<ITickerCtx>(initState);

interface IProps {
  children: ReactNode;
  ctxState: ITickerCtx;
}

export const TickerCtxProvider = ({ children, ctxState }: IProps) => {
  return <TickerCtx.Provider value={ctxState}>{children}</TickerCtx.Provider>;
};

export const useTickerCtx = () => {
  const ctx = useContext(TickerCtx);
  if (!ctx) throw Error("useTickerCtx: TickerCtx is not defined!");

  return ctx;
};
